var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCultxLockV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6396 11.843H9.36035C7.94458 11.843 6.79688 12.9907 6.79688 14.4064V24.0451C6.79688 25.4609 7.94458 26.6086 9.36035 26.6086H20.6396C22.0554 26.6086 23.2031 25.4609 23.2031 24.0451V14.4064C23.2031 12.9907 22.0554 11.843 20.6396 11.843Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36035 9.03046C9.36035 5.91561 11.8852 3.39081 15 3.39081C18.1148 3.39081 20.6396 5.91561 20.6396 9.03046V11.843H17.8271V9.03046C17.8271 7.47186 16.5592 6.20331 15 6.20331C13.4408 6.20331 12.1729 7.47186 12.1729 9.03046V11.843H9.36035V9.03046Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9453 18.9434V23.4451H16.0547V18.9434C16.6852 18.5783 17.1094 17.8975 17.1094 17.117C17.1094 15.9522 16.1648 15.0076 15 15.0076C13.8352 15.0076 12.8906 15.9522 12.8906 17.117C12.8906 17.8975 13.3148 18.5789 13.9453 18.9434Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCultxLockV2);
export default __webpack_public_path__ + "static/media/cultx-lock-v2.5f227d294db3a3960ef2730976ac580a.svg";
export { ForwardRef as ReactComponent };